import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ElementiUdComponent } from "@app/gestione-fascicoli/dettaglio-documento/componenti/elementi-ud/elementi-ud.component";
import { MatAutocompleteModule, MatBadgeModule, MatBottomSheetModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDialogModule, MatDividerModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatStepperModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatTreeModule } from "@angular/material";
import { UtilityModule } from "@app/utility/utilty.module";
import { StoricoDocumentoComponent } from "@app/gestione-fascicoli/dettaglio-documento/componenti/storico-documento/storico-documento.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RicercaDipendentiComponent } from "./components/ricerca-dipendenti/ricerca-dipendenti.component";
import { AutocompleteDipendenteComponent } from "./components/autocomplete-dipendente/autocomplete-dipendente.component";
import { BsDatepickerModule, TabsModule, TypeaheadModule } from "ngx-bootstrap";
import { UploadFileComponent } from "./components/upload-file/upload-file.component";
import { FileUploadModule } from "ng2-file-upload";
import { RicercaDocumentoComponent } from "./components/ricerca-documento/ricerca-documento.component";
import { ModaleRicercaDocumentoComponent } from "./components/modale-ricerca-documento/modale-ricerca-documento.component";
import { RisultatiRicercaDocumentiComponent } from "./components/risultati-ricerca-documenti/risultati-ricerca-documenti.component";
import { UploadMultiFileComponent } from "./components/upload-multi-file/upload-multi-file.component";
import { ModaleEstensoriComponent } from "./components/modale-estensori/modale-estensori.component";
import { ModaleComponentiCollegioComponent } from "./components/modale-componenti-collegio/modale-componenti-collegio.component";
import { ListaDadComponent } from "./components/lista-dad/lista-dad.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { InputAttiDadComponent } from "./components/input-lista-dad/input-atti-dad.component";
import { ContatoreAttiComponent } from "./components/contatore-atti/contatore-atti.component";
import { RicercaStrutturaFormComponent } from "./components/ricerca-struttura-form/ricerca-struttura-form.component";

import { ValoreCampoSpecificoManualeComponent } from "./components/valore-campo-specifico-manuale/valore-campo-specifico-manuale.component";
import { ValoriCampoSpecificoComponent } from "./components/valori-campo-specifico/valori-campo-specifico.component";
import { ValoreCampoSpecificoEsternoComponent } from "./components/valore-campo-specifico-esterno/valore-campo-specifico-esterno.component";
import { ValoreCampoSpecificoLiberoComponent } from "./components/valore-campo-specifico-libero/valore-campo-specifico-libero.component";

import { ModaleDestinatariComponent } from "./components/modale-destinatari/modale-destinatari.component";
import { TabDestinatariComponent } from "./components/tab-destinatari/tab-destinatari.component";
import { TabDestinatariDipendentiComponent } from "./components/tab-destinatari-dipendenti/tab-destinatari-dipendenti.component";
import { TabDestinatariInterniComponent } from "./components/tab-destinatari-interni/tab-destinatari-interni.component";
import { ModaleRicercaAvanzataAnagrafeComponent } from "./components/modale-ricerca-avanzata-anagrafe/modale-ricerca-avanzata-anagrafe.component";
import { ModaleRicercaListeDistribuzioneComponent } from "./components/modale-ricerca-liste-distribuzione/modale-ricerca-liste-distribuzione.component";
import { VociBilancioComponent } from './components/voci-bilancio/voci-bilancio/voci-bilancio.component';
import { ModaleDatiContabiliComponent } from "@app/gestione-atti/modale-dati-contabili/modale-ricerca-conti/modale-dati-contabili.component";
import { TypeAheadRicercaDecretiComponent } from "./components/type-ahead-ricerca-decreti/type-ahead-ricerca-decreti.component";
import { TypeAheadOggettoNotaComponent } from "./components/type-ahead-oggetto-nota/type-ahead-oggetto-nota.component";
import { TypeAheadRicercaNoteComponent } from "./components/type-ahead-ricerca-note/type-ahead-ricerca-note.component";
import { ModaleAggiungiDatiDecretoComponent } from "./components/modale-aggiungi-dati-decreto/modale-aggiungi-dati-decreto.component";
import { ModaleAggiungiBeneficiarioComponent } from "./components/modale-aggiungi-beneficiario/modale-aggiungi-beneficiario.component";
import { NumericOnlyDirective } from "./directive/numeric-only.directive";
import {SelectDecretoComponent} from "@app/shared/components/select-decreto/select-decreto.component";
import { SelectDecretoControlComponent } from "@app/shared/components/select-decreto-control/select-decreto-control.component";
import { BackgroundOperationsComponent } from "./components/background-operations/background-operations.component";
import { ContatoreNoteComponent } from "./components/contatore-note/contatore-note.component";

@NgModule({
  declarations: [
    ElementiUdComponent,
    StoricoDocumentoComponent,
    RicercaDipendentiComponent,
    AutocompleteDipendenteComponent,
    ModaleDestinatariComponent,
    TabDestinatariComponent,
    ModaleRicercaListeDistribuzioneComponent,
    TabDestinatariDipendentiComponent,
    TabDestinatariInterniComponent,
    UploadFileComponent,
    TypeAheadRicercaDecretiComponent,
    TypeAheadOggettoNotaComponent,
    TypeAheadRicercaNoteComponent,
    RicercaStrutturaFormComponent,
    UploadMultiFileComponent,
    RicercaDocumentoComponent,
    ModaleRicercaDocumentoComponent,
    ModaleEstensoriComponent,
    ModaleComponentiCollegioComponent,
    ModaleAggiungiDatiDecretoComponent,
    ModaleAggiungiBeneficiarioComponent,
    ListaDadComponent,
    InputAttiDadComponent,
    ContatoreAttiComponent,
    ModaleRicercaAvanzataAnagrafeComponent,
    RisultatiRicercaDocumentiComponent,
    VociBilancioComponent,
    ValoreCampoSpecificoManualeComponent,
    ValoreCampoSpecificoEsternoComponent,
    ValoreCampoSpecificoLiberoComponent,
    ValoriCampoSpecificoComponent,
    ModaleDatiContabiliComponent,
    SelectDecretoComponent,
    SelectDecretoControlComponent,
    NumericOnlyDirective,
    BackgroundOperationsComponent,
    ContatoreNoteComponent],
  imports: [
    TabsModule,
    FormsModule,
    CommonModule,
    UtilityModule,
    NgxDatatableModule,
    TypeaheadModule,
    ReactiveFormsModule,
    FileUploadModule,
    DragDropModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatBadgeModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatStepperModule,
    MatSortModule,
    MatIconModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatSelectModule,
    MatTreeModule,
    MatProgressSpinnerModule,
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    ElementiUdComponent,
    RicercaDipendentiComponent,
    AutocompleteDipendenteComponent,
    TabDestinatariComponent,
    ModaleRicercaAvanzataAnagrafeComponent,
    ModaleRicercaListeDistribuzioneComponent,
    UploadFileComponent,
    UploadMultiFileComponent,
    RicercaStrutturaFormComponent,
    RicercaDocumentoComponent,
    ModaleRicercaDocumentoComponent,
    RisultatiRicercaDocumentiComponent,
    ModaleEstensoriComponent,
    TabDestinatariDipendentiComponent,
    TabDestinatariInterniComponent,
    TypeAheadRicercaDecretiComponent,
    SelectDecretoComponent,
    SelectDecretoControlComponent,
    TypeAheadOggettoNotaComponent,
    TypeAheadRicercaNoteComponent,
    ListaDadComponent,
    InputAttiDadComponent,
    ContatoreAttiComponent,
    ModaleComponentiCollegioComponent,
    ModaleDestinatariComponent,
    ValoreCampoSpecificoManualeComponent,
    ValoreCampoSpecificoEsternoComponent,
    ValoreCampoSpecificoLiberoComponent,
    ValoriCampoSpecificoComponent,
    VociBilancioComponent,
    MatProgressSpinnerModule,
    MatBadgeModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    ModaleAggiungiDatiDecretoComponent,
    ModaleAggiungiBeneficiarioComponent,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatBadgeModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatIconModule,
    MatTableModule,
    MatTabsModule,
    MatStepperModule,
    MatToolbarModule,
    MatTooltipModule,
    MatSelectModule,
    MatTreeModule,
    MatProgressSpinnerModule,
    NumericOnlyDirective,
    BackgroundOperationsComponent,
    ContatoreNoteComponent,
  ],
})
export class SharedModule { }
